import { createTranslationRef } from '@backstage/frontend-plugin-api';

const apiDocsTranslationRef = createTranslationRef({
  id: "api-docs",
  messages: {
    apiDefinitionDialog: {
      closeButtonTitle: "Close",
      tabsAriaLabel: "API definition options",
      toggleButtonAriaLabel: "Toggle API Definition Dialog"
    },
    defaultApiExplorerPage: {
      title: "APIs",
      subtitle: "{{orgName}} API Explorer",
      pageTitleOverride: "APIs",
      createButtonTitle: "Register Existing API",
      supportButtonTitle: "All your APIs"
    },
    consumedApisCard: {
      title: "Consumed APIs",
      error: {
        title: "Could not load APIs"
      },
      emptyContent: {
        title: "This {{entity}} does not consume any APIs."
      }
    },
    hasApisCard: {
      title: "APIs",
      error: {
        title: "Could not load APIs"
      },
      emptyContent: {
        title: "This {{entity}} does not contain any APIs."
      }
    },
    providedApisCard: {
      title: "Provided APIs",
      error: {
        title: "Could not load APIs"
      },
      emptyContent: {
        title: "This {{entity}} does not provide any APIs."
      }
    },
    apiEntityColumns: {
      typeTitle: "Type",
      apiDefinitionTitle: "API Definition"
    },
    consumingComponentsCard: {
      title: "Consumers",
      error: {
        title: "Could not load components"
      },
      emptyContent: {
        title: "No component consumes this API."
      }
    },
    providingComponentsCard: {
      title: "Providers",
      error: {
        title: "Could not load components"
      },
      emptyContent: {
        title: "No component provides this API."
      }
    },
    apisCardHelpLinkTitle: "Learn how to change this"
  }
});

export { apiDocsTranslationRef };
//# sourceMappingURL=translation.esm.js.map
